import api from '@/services/api/api';

export const useDocuments = (filters = {}) => {
  const documents = useQuery(
    ['documents', filters],
    async () => {
      const { data } = await api.documents.getDocuments(toValue(filters));
      return data;
    },
    { select: ({ data }) => data },
  );

  onServerPrefetch(async () => {
    await documents.suspense();
  });

  return {
    documents,
  };
};
